module.exports = "\r\n    \r\n        <div class=\"page-not-found \">\r\n            <div class=\"unauthorize-content\">\r\n                    <h1>Access forbidden</h1>\r\n                    <p>Sorry, You are not authorize to view this page!</p>\r\n                    <a class=\"btn btn-404\" href=\"/\">Go To Home</a>\r\n           </div>\r\n        </div>\r\n  \r\n\r\n"


//////////////////
// WEBPACK FOOTER
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/unauthorizePage/unauthorize-page.component.html
// module id = ../../../../../app/shared/components/unauthorizePage/unauthorize-page.component.html
// module chunks = main